import { TextBox } from "../core/components/textBox.js";
import { Button } from "../core/components/button.js";
import { Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { Config } from "../core/config/config.js";
import { DocumentPreview } from "../documents/documents.js";
import { SimpleCheckBox } from "../core/components/simpleCheckBox.js";
import { FAIcon } from "../core/components/faIcon.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { EventType } from "../../siteManagement/eventManager.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { DefaultProfilePictureGenerator } from "../core/util/defaultProfilePictureGenerator.js";
import { EntityTicket, TicketAppPropsContext } from "./ticket.js";
import { BaseField } from "../core/components/baseComponentProps.js";
import React from "react";
interface TicketAppConversationHistoryState {
    commentType: number;
    filterType: number[];
    isTextFocused: boolean;
}

export class ConversationHistory extends React.Component<TicketAppConversationHistoryProps, TicketAppConversationHistoryState> {
    private _stufe = -1;
    // @ts-ignore
    private readonly _bubbleStyle: React.CSSProperties = {
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingRight: "3px",
        paddingLeft: "3px",
        marginTop: "5px",
        boxShadow: "0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12)",
        backgroundColor: "#E0E0E0",
        lineHeight: "1.5em",
        borderRadius: "var(--border-radius)"
    };

    private users: UserInfo[] = [];
    private mentioningMenuActive = Config.settings.teamsIntegrationActive && !Helper.useMobileGui();
    readonly #css = `#ddMenu_mn_active > div {
                            left: -130px !important
                     }
                     #conversation_history_event a, .conversation_history_event a:visited, .conversation_history_event a:active {
                        color: #173D78;
                     }`;

    // @ts-ignore
    private readonly _userStyle: React.CSSProperties = {
        backgroundColor: "#546E7A",
        color: "white",
        gridColumn: "1/4",
        gridRow: "1/3",
        borderRadius: "var(--border-radius)"
    };

    // @ts-ignore
    private readonly _foreignStyle: React.CSSProperties = {
        gridColumn: "3/6",
        gridRow: "1/3"
    };

    // @ts-ignore
    private readonly _eventStyle: React.CSSProperties = {
        backgroundColor: "white",
    };

    private _offsetWidth = null;
    private _offsetHeight = null;
    private _scrollAndFocus = false;
    private _commentsContainer = null;
    private readonly _levelLabel = null;
    private _addText = "";
    //private _isTextFocused = false;
    private _currentEditableComment: { entry: TicketConversation, text: string, texttype: number } = { entry: null, text: null, texttype: null }
    private _commentType = (): number => { return (this.state.commentType) }
    private _filterType = (): Array<number> => { return (this.state.filterType) }
    //private _textBoxAddProps: TextBoxProps = null;
    private _isCommentFiltred = (ct: number): boolean => {
        const ft = this.state.filterType.slice(0);
        return (ft.indexOf(Number(ct)) === -1);
    }
    private _isConversationModel = (): boolean => { return ((this.props.field.model === "entity.Conversation")) }
    private _ddMenu: kendo.ui.Menu;

    constructor(props: TicketAppConversationHistoryProps) {
        super(props);
        this._stufe = Helper.evalEntityProperty<EntityTicket>("Stufe", props.handleEval);
        this._levelLabel = this.props.context.translations["Field.Vorgang.stufe"];
        this._setEvents();
        this._loadUsers().then();

        let ft = Helper.loadDataFromStorage("conversationHistoryFilter");
        if (!Helper.hasValue(ft))
            ft = [1, 2, 3, 4]
        this.state = {
            commentType: 1,
            filterType: ft,
            isTextFocused: false
        }
    }


    private _loadUsers = async () => {
        const data = await HTTPService.get<UserInfo[]>("ProcedureLookup/GetUsersForMentioning?problemNr=" + this.props.entity.ProblemNr);
        this.users = data.sort((a, b) => {
            if (a.Weight > b.Weight) {
                return -1;
            }
            if (a.Weight < b.Weight) {
                return 1;
            }

            if (a.Name < b.Name)
                return -1;

            if (a.Name > b.Name)
                return 1;

            return 0;
        });
        this.setState({})
    }

    private _commentTypeText = (ct: Number) => {

        switch (ct) {
            case 2:
                return Helper.getTranslation("Field.Vorgang.anmerkung");
            case 3:
                return Helper.getTranslation("WebSMS.Procedure.RectificationText");
            default:
                return Helper.getTranslation("Regionen.Vorgang.Beschreibung");
        }
    }

    private _canWrite = (): boolean => {
        return (this.props.handleEval("entity.RecordRight.CanWrite"));
    }

    private _canEdit = (instance: TicketConversation): boolean => {
        // Wenn schon ein Kommentar im Edit Modus ist, dann kann kein anderer auch in den Editmodus übergehen
        if (!this._canWrite() || this._currentEditableComment.entry !== null)
            return false;

        // Kommentar ist editerbar wenn der Hotliner der aktuelle User ist und der Kommentar in der aktuellen Stufe erfolgte
        // Zusätzlich darf kein anderer User einen Kommentar abgesetzt haben
        // oder nicht gespeichert 
        if ((instance.Name === Config.user.userName && instance.Level === this.props.handleEval("entity.Stufe")) || instance.IsSaved === false) {
            const index = this.props.comments.sort((n1, n2) => {
                if (n1.AddDate > n2.AddDate) {
                    return 1;
                }
                if (n1.AddDate < n2.AddDate) {
                    return -1;
                }
            }).indexOf(instance);

            for (let i = index + 1; i < this.props.comments.length; i++) {
                if (this.props.comments[i].Name !== Config.user.userName)
                    return false;
            }
        }
        else {
            return false;
        }

        return true;
    }

    private _renderEntry = (entry: { type: string, timestamp: string, obj: any }, index: number) => {
        if (entry.type === "comment")
            return this._renderComment(entry.obj, index);
        else
            return this._renderEvent(entry.obj, index)
    }

    private _renderMenu = (ct: any, isInEdit: boolean) => {
        return (this._isConversationModel()) ? <ConversationFilter commentTypeText={this._commentTypeText} ct={ct} isInEdit={isInEdit} isCommentFiltred={this._isCommentFiltred} onItemCheckBoxChange={this.onItemCheckBoxChange} /> : null;
    }

    private _createRadioButtons = (isDisabled: boolean) => {

        let items = [
            {
                Text: this._commentTypeText(1),
                Value: 1,
                Checked: this._commentType() == 1,
                Disabled: this._isCommentFiltred(1) || isDisabled
            },
            {
                Text: this._commentTypeText(2),
                Value: 2,
                Checked: this._commentType() == 2,
                Disabled: this._isCommentFiltred(2) || isDisabled
            },
            {
                Text: this._commentTypeText(3),
                Value: 3,
                Checked: this._commentType() == 3,
                Disabled: this._isCommentFiltred(3) || isDisabled
            }
        ];
        const ct = this._commentType();
        const isInEdit = this._currentEditableComment.entry !== null;
        const ddMenu = this._renderMenu(ct, isInEdit);

        // @ts-ignore
        const style: React.CSSProperties = {
            marginBottom: "5px",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center"
        }

        if (Config.user.isExternal) {
            items.splice(1, 1);
        }

        let buttons = items.map((b, i) => {
            const id = `rb-commenttype${i}`;
            const className_radiolabel = "k-radio-label legend_radio_type" + b.Value.toString();
            return (
                <div key={id} style={{ whiteSpace: "nowrap", marginRight: "10px" }}>
                    <input type="radio" id={id} value={b.Value} className="k-radio k-radio-md k-valid" onChange={(e) => this._clickChangeCommentarType(e.target.value)}
                        checked={b.Checked} disabled={b.Disabled} />
                    <label htmlFor={id} className={className_radiolabel}>{b.Text}</label>
                </div>
            );
        });


        return (
            <div style={style}>
                {buttons}
                {ddMenu}
            </div>
        );

    }

    private _clearCurrentEditableComment = () => {
        this._currentEditableComment.entry = null;
        this._currentEditableComment.text = null;
        this._currentEditableComment.texttype = null;
    }


    private _doSaveTextAndType = () => {
        let isTypeChanged = false;

        if (this._currentEditableComment.entry.Text !== this._currentEditableComment.text) {
            this._currentEditableComment.entry.Text = this._currentEditableComment.text;
            this._currentEditableComment.entry.IsChanged = true;
        }

        if (this._currentEditableComment.entry.Type != this._currentEditableComment.texttype) {
            this._currentEditableComment.entry.Type = this._currentEditableComment.texttype;
            this._currentEditableComment.entry.IsChanged = true;
            isTypeChanged = true;
        }

        this.props.onChange(this.props.field, this.props.comments);

        if (isTypeChanged)
            this.setState({ commentType: this._currentEditableComment.texttype })
        else
            this.setState({});

    };

    private highlight = (text = '', highlights = []) => {
        if (!Array.isArray(highlights) || highlights.length === 0) {
            return text;
        }

        // Erstellen eines regulären Ausdrucks, der alle Begriffe im Array berücksichtigt
        const escapedHighlights = highlights
            .filter(Helper.hasValue) // Nur gültige Werte berücksichtigen
            .map(Helper.escapeRegExp); // Sonderzeichen in Suchbegriffen escapen

        if (escapedHighlights.length === 0) {
            return text;
        }

        const regex = new RegExp(`(${escapedHighlights.join('|')})`, 'gi'); // Zusammenfügen der Begriffe mit `|` als ODER-Operator

        const parts = text.split(regex);
        return (
            <span>
                {parts.filter(part => part).map((part) => (
                    regex.test(part)
                        ? <mark key={kendo.guid()}>{part}</mark>
                        : <span key={kendo.guid()}>{part}</span>
                ))}
            </span>
        );
    };

    private urlify = (text: string, isUser: boolean) => {
        const fontColor = (isUser ? "#e0e0e0" : "#767676");
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.split(urlRegex).map((s, index) => {
            let key = Helper.getHashCode(s) + "_" + index;
            if (s.match(urlRegex)) {
                return <a key={key} href={s} style={{ color: fontColor }} target="_blank" >{s}</a>
            }
            return <React.Fragment key={key}>{this.highlight(s, this.props.textToHighlight)}</React.Fragment>

        });
    }

    private _renderComment = (instance: TicketConversation, index: number) => {
        const thisUser = Config.user.userName === instance.Name;

        let textArea = null;
        let saveButton = null;
        let cancelButton = null;
        let offsetWidth = null;
        let dropDownList = null;

        if (this._currentEditableComment.entry !== null && this._currentEditableComment.entry.Id === instance.Id) {
            const textBoxProps = ComponentHelper.createFactory().getDefaultTextBoxProps();
            textBoxProps.field.multiLine = true;

            textBoxProps.onChange = (_property, value) => {
                this._currentEditableComment.text = value;
                this.forceUpdate();
            };

            let offsetHeight: number;
            offsetWidth = 300;

            const el = document.getElementById(instance.Id);
            if (el) {

                offsetHeight = Math.max(el.scrollHeight, 80);
                offsetHeight = Math.min(offsetHeight, 400);
                offsetWidth = el.scrollWidth + 20;
                this._offsetWidth = offsetWidth;
                this._offsetHeight = offsetHeight;
            } else {
                offsetWidth = this._offsetWidth;
                offsetHeight = this._offsetHeight;
            }

            textBoxProps.textAreaHeight = `${offsetHeight}px`;

            // @ts-ignore
            textBoxProps.onKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
                if (e.key === 'Enter' && e.shiftKey) {
                    this._currentEditableComment.text = (e.target as any).value;
                    this.forceUpdate();
                    this._doSaveTextAndType();
                    this._clearCurrentEditableComment();
                }
            };

            // @ts-ignore
            textBoxProps.onKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
                if (e.key === 'Escape') {
                    //console.log("textBoxProps.Escape")
                    this._clearCurrentEditableComment();
                    this.setState({});
                }
            }

            textArea = <TextBox {...textBoxProps} value={instance.Text} />

            saveButton = <Button iconName="check" title={Config.translations.savePerCrtlShift}
                handleClick={() => {
                    this._doSaveTextAndType();
                    this._clearCurrentEditableComment();
                }}
            />;
            cancelButton = <Button iconName="ban" title={Config.translations.cancelEscape}
                handleClick={() => {
                    this._clearCurrentEditableComment();
                    this.setState({});
                }}
            />;

            if (this._isConversationModel()) {
                let dropDown = ComponentHelper.createFactory().getDefaultDropDownProps();
                dropDown.field.optionLabel = "";
                dropDown.dataSource = [];

                if (!this._isCommentFiltred(1)) {
                    dropDown.dataSource.push({ Value: 1, Text: this._commentTypeText(1) });
                }
                if (!this._isCommentFiltred(2) && !Config.user.isExternal) {
                    dropDown.dataSource.push({
                        Value: 2, Text: this._commentTypeText(2)
                    });
                }
                if (!this._isCommentFiltred(3)) {
                    dropDown.dataSource.push({ Value: 3, Text: this._commentTypeText(3) });
                }


                //dropDown.field.optionLabel = "Typ ändern";
                dropDown.field.dataTextField = "Text";
                dropDown.field.dataValueField = "Value";
                dropDown.value = Number(this._commentType());

                dropDown.disabled = this._currentEditableComment.entry.Text != instance.Text;

                dropDown.onChange = (_field: { model: string }, value: any) => {
                    if (value != "" && value != this._currentEditableComment.entry.Type) {
                        this._currentEditableComment.texttype = value;
                        this._triggerValueText();
                    }
                };

                dropDownList = <DropDownList {...dropDown} />;
            }
        }
        // @ts-ignore
        const style: React.CSSProperties = textArea ? null : this._bubbleStyle;

        let editButton = null;
        if (this._canEdit(instance)) {
            editButton = <Button buttonStyle={{ backgroundColor: "transparent", width: "12px", height: "12px", border: "none" }} iconStyle={{}} iconName="edit" title={Config.translations.savePerCrtlShift}
                handleClick={() => {
                    this._currentEditableComment.entry = instance;
                    this._currentEditableComment.text = instance.Text;
                    this._currentEditableComment.texttype = instance.Type;
                    this.setState({ commentType: instance.Type });
                }}
            />;
        }

        let extendet = "";

        if (this._isConversationModel()) {


            let type_text = this._commentTypeText(instance.Type);

            const ft = this._filterType();

            if (ft.indexOf(instance.Type) === -1) {
                return null;
            }

            if (Config.user.isExternal && (instance.Type === 2)) {
                return null;
            }

            extendet = `${type_text}`;
        }
        const classNameText = "legend_label_type" + instance.Type.toString();
        const className = "legend_label_type " + (thisUser ? "legend_self_type" + instance.Type.toString() : "legend_other_type" + instance.Type.toString());

        const regex = /\[~[A-Za-z0-9]+\]/gm;
        let displayText = instance.Text;
        if (Helper.isNullOrEmpty(displayText)) {
            displayText = "";
        }
        let match: RegExpExecArray;

        const replaceAll = (str: string, pattern: string, replacement: string) => {
            const arr = str.split(pattern);
            return arr.join(replacement)
        }

        do {
            match = regex.exec(displayText);

            if (match) {
                const pwUser = match[0].replace("[~", "").replace("]", "")
                const user = this.users.find(user => user.Login.toLowerCase() == pwUser.toLowerCase())
                if (user) {
                    displayText = replaceAll(displayText, match[0], `@${user.Name}`)
                }
            }
        } while (match);

        let delFont = null; 
        let delIcon = null;
        if (Helper.isNullOrEmpty(displayText)) {
            displayText = Helper.getTranslation("WebSMS.Log.Gelöscht");
            delFont = "italic"
            delIcon = (<i className="fal fa-trash" style={{marginRight: 5}} />);
        }
        
        const user = this.users.find(user => user.Login.toLowerCase() == instance.Name.toLowerCase())
        return (
            <div key={index} style={{ marginBottom: "15px", maxWidth: "90%", alignSelf: thisUser ? "flex-end" : "flex-start", minWidth: (offsetWidth) ? `${offsetWidth}px` : null }} >
                <label className="conversation-history__label" style={{ textAlign: thisUser ? "right" : null }}>
                    {instance.IsSaved ? null : <span style={{ color: "red", paddingRight: "3px" }}>*</span>}{(instance.FullName ?? instance.Name)} - {this._levelLabel} {instance.Level} - {kendo.toString(kendo.parseDate(instance.AddDate), "G")} {extendet == "" ? null : " - "} {extendet == "" ? null : <span className={classNameText}>{extendet}</span>}
                </label>
                {editButton}
                <div style={{ display: "grid", gridTemplateColumns: "40px 5px 1fr", gridTemplateRows: "40px auto", marginTop: "5px" }} >
                    <div style={{ ...style, ...(thisUser ? this._userStyle : this._foreignStyle) }}>
                        <div className={className}>
                            {textArea ? textArea : < p id={instance.Id} style={{ wordBreak: "break-word", whiteSpace: "pre-wrap", padding: "0 3px", fontStyle: delFont }}>{delIcon}{this.urlify(displayText, thisUser)}</p>}
                            <div className={className} style={{ border: "none" }} >
                                {saveButton && cancelButton ?
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        {dropDownList ? <div className="conversation-history__edit-type" style={{ justifyContent: "flex-start", padding: "1px", maxWidth: 200 }}> {dropDownList} </div> : null}
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            {saveButton}
                                            {cancelButton}
                                        </div>
                                    </div>
                                    : null}
                            </div>
                        </div>

                    </div>
                    <ProfilePictureWrapper userInfo={user} />
                </div>
            </div>
        );
    }

    private _updateHistoryEvent(isGuids: string[]) {

        HTTPService.get<JsonResultClass<EventEntry[]>>("Procedure/GetEvents/?problemNr=" + encodeURI(this.props.entity.ProblemNr.toString()))
            .then(events_result => {
                let changed = false;

                //remove from history deleted items
                let newEvents = events_result.Data.filter(x => isGuids.includes(x.DokuGuid) && !Helper.hasValue(x.DokuId));
                newEvents.forEach(e => {
                    const found = this.props.events.filter(ee => ee.DokuGuid == e.DokuGuid);
                    found.sort((a, b) => a.UtcDateTime ? -1 : b.UtcDateTime ? 1 : 0);
                    if (found.length > 0) {
                        const idx = this.props.events.indexOf(found[0]);
                        this.props.events.splice(idx, 1);
                        changed = true;
                    }
                });

                //update
                newEvents = events_result.Data.filter(x => isGuids.includes(x.DokuGuid) && Helper.hasValue(x.DokuId));
                newEvents.forEach(e => {
                    const found = this.props.events.filter(ee => ee.DokuGuid == e.DokuGuid);
                    found.sort((a, b) => a.UtcDateTime ? -1 : b.UtcDateTime ? 1 : 0);
                    if (found.length > 0) {
                        const idx = this.props.events.indexOf(found[0]);
                        this.props.events[idx] = e;
                        changed = true;
                    }
                });

                //add new
                newEvents = events_result.Data.filter(x => isGuids.includes(x.DokuGuid));
                let currEvents = this.props.events.filter(x => isGuids.includes(x.DokuGuid));
                if (currEvents.length > 0) {
                    let lastEvent = currEvents.reduce((prev, curr) => prev.UtcDateTime > curr.UtcDateTime ? prev : curr);
                    newEvents = newEvents.filter(x => x.UtcDateTime > lastEvent.UtcDateTime);
                }

                if (Helper.hasValue(newEvents) && newEvents.length > 0) {
                    this.props.events.push(...newEvents);
                    changed = true;
                }


                if (!changed)
                    return;

                this.setState({});
            });
    }
    private _renderEvent = (instance: EventEntry, index: number) => {
        // @ts-ignore
        const style: React.CSSProperties = this._bubbleStyle;

        if (this._isConversationModel()) {
            const ft = this._filterType();
            if (ft.indexOf(4) === -1) {
                return null;
            }
        }
        let preview = <div style={{ flex: 1, marginTop: "15px" }}><DocumentPreview
            contextType={this.props.context.contextType}
            entityId={this.props.context.contextType == "ticket" ? this.props.entity.ProblemNr : ""}
            filename={instance.DokuFilename} dokuGuid={instance.DokuGuid} isChatLayout={true}
            handleEval={this.props.handleEval} additionalUrlParams={this.props.additionalUrlParams} /></div>;

        let userFullName = instance.UserFullName;
        let status = null;
        let statusComma = null;

        const setClass = (className: string, tag: string) => {
            return `<span class="conversationhistory--${className}">${tag}</span>`
        }

        let html = setClass("text", instance.Text);
        //docs
        if (Helper.hasValue(instance.DokuTitle) && Helper.hasValue(instance.DokuRemark)) {
            html = setClass("title", instance.DokuTitle) + " " + setClass("text", instance.Text) + "</br>" + setClass("remark", instance.DokuRemark);
        }
        if (Helper.hasValue(instance.DokuId)) {
            html += "</br><label class='conversationhistory--internextern' style='font-size: 0.9em'>" + (instance.DokuNurIntern == 1 ? Helper.getTranslation("Dokument.Intern") : Helper.getTranslation("Dokument.Extern")) + " - " + setClass("category", instance.DokuKategory) + "</label>";
        }
        //emails
        if (Helper.hasValue(instance.JobId)) {
            const _to = Helper.getTranslation("WebCRM.Email.Recipient");
            const _cc = Helper.getTranslation("WebCRM.Email.CCEmails");
            const _bcc = Helper.getTranslation("WebCRM.Email.BCCEmails");

            const _status = Helper.getTranslation("WebCRM.Email.EmailStatus");

            const _body = Helper.getTranslation("WebCRM.Email.EmailBody");

            const _files = Helper.getTranslation("WebCRM.Email.LocalFileSummary");
            const _docs = Helper.getTranslation("WebCRM.Email.DocumentSummary");

            const _preview = Helper.getTranslation("WebSMS.Documents.ShowPreview");

            //1. text from server-translation xxxxx.Created2 => Email "123" was created => instance.Text
            if (Helper.hasValue(instance.Email)) {
                if (Helper.hasValue(instance.Email.SenderEmail))
                    userFullName += " <" + instance.Email.SenderEmail + ">";

                //2. status 
                if (Helper.hasValue(instance.EmailStatus)) {

                    // @ts-ignore
                    const style: React.CSSProperties = {
                        fontSize: "10px",
                        color: "red"
                    };

                    if (instance.EmailStatus == 0)
                        style.color = "blue";
                    if (instance.EmailStatus == 1)
                        style.color = "green";

                    status = Helper.hasValue(instance.EmailError) ?
                        (<><a style={style} title={instance.EmailError}>{_status}: {instance.EmailStausText}</a></>) :
                        (<><label style={style}>{_status}: {instance.EmailStausText}</label></>);

                    statusComma = ", ";
                }

                //3. attachments und documents
                html += ", " + _files + ": " + instance.Email.Documents.length + ", " + _docs + ": " + instance.Email.FileNames.length;

                preview = <div style={{ flex: 1, marginTop: "15px" }}><a href={`${Config.baseUrl}EmailSender/Show/${instance.JobId}`} target="_blank">{_preview}</a></div>;

                //4. To => Recipients, CC, BCC
                const sendTo: string[] = [];

                if (Helper.hasValue(instance.Email.RecipientEmails) && instance.Email.RecipientEmails.length > 0)
                    sendTo.push(_to + ": " + instance.Email.RecipientEmails);
                if (Helper.hasValue(instance.Email.CCEmails) && instance.Email.CCEmails.length > 0)
                    sendTo.push(_cc + ": " + instance.Email.CCEmails);
                if (Helper.hasValue(instance.Email.BCCEmails) && instance.Email.BCCEmails.length > 0)
                    sendTo.push(_bcc + ": " + instance.Email.BCCEmails);

                if (sendTo.length > 0)
                    html += "</br>" + sendTo.join(";");
            }

            //5. body
            if (Helper.hasValue(instance.Email.EmailBody))
                html += `</br><label>${_body}: ${instance.Email.EmailBody}</label>`;
        }
        return (
            <div key={index} className="conversation-history__event" id={"conversation_history_event"}>
                <label className="conversation-history__label">
                    {userFullName} - {kendo.toString(kendo.parseDate(instance.UserDateTime), "G")}{statusComma}
                </label>
                {status}
                <div style={{ ...style, ...this._eventStyle }}>
                    <p dangerouslySetInnerHTML={{ __html: html }} style={{ whiteSpace: "pre-wrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}></p>
                </div>
                {preview}
            </div>
        );
    }

    private _createNewComment = () => {
        const newInstance: TicketConversation = {
            AddDate: Helper.dates.getISODateString(new Date()),
            Id: kendo.guid(),
            IsSaved: false,
            IsChanged: false,
            Level: this._stufe,
            Name: Config.user.userName,
            FullName: Config.user.fullName,
            Text: "",
            Type: this.props.conversationType,
            UTCAddDate: null
        };

        return newInstance;
    }


    private _updateEvent = (cus: { command: string, isGuids: string[] }) => {
        if (cus.command === "historyEventUpdate") {
            this._updateHistoryEvent(cus.isGuids);
        }
    }

    private _setEvents = () => {

        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "addTicketText") {
                //add or update or both
                if (Helper.hasValue(this._currentEditableComment.entry)) {
                    this._doSaveTextAndType();
                    this._clearCurrentEditableComment();
                }

                this._add();
            }
            if (cus.command === "deleteTicketText") {
                if (Helper.hasValue(this._currentEditableComment.entry))
                    this._clearCurrentEditableComment();

                this._addText = "";
                this.setState({});
                //if (this._textBoxAddProps) {
                //    this._textBoxAddProps.value = "";
                //    this._addText = "";
                //}
            }
        });

        General.Events.bind(EventType.Custom, this._updateEvent);
        General.Events.bind(EventType.SavedSuccessfully, this._loadUsers);


    }


    private _add = () => {
        if (Helper.hasValue(this._addText) && this._addText.trim() !== "") {
            let newComment = this._createNewComment();
            newComment.Text = this._addText;
            if (this._isConversationModel()) {
                newComment.Type = Number(this.state.commentType);
            }

            this._addText = "";
            this._scrollAndFocus = true;

            this.props.onAdd(newComment);

            this.setState({});
        }
    }

    public scrollAndFocusComponent = () => {
        this._commentsContainer.scrollTop = this._commentsContainer.scrollHeight;
        $("textarea", this._commentsContainer).trigger("focus")
    }

    private _clickChangeCommentarType(id: any) {
        this._currentEditableComment.entry = null;
        this._currentEditableComment.text = null;
        const ft = this.state.filterType.slice(0);
        const idx = ft.indexOf(id);
        if (idx > -1) {
            ft.splice(idx, 1);

            this.setState({
                commentType: id,
                filterType: ft
            })

        } else {
            this.setState({
                commentType: id
            });
        }
    }

    componentWillUnmount() {
        General.Events.unbind(EventType.Custom, this._updateEvent);
        if (this._ddMenu)
            this._ddMenu.destroy();
    }

    componentDidMount() {
        $(`.field-instance[data-model="${this.props.field.model}"]`).css("background-color", "transparent");
        this.scrollAndFocusComponent();
    }

    private _triggerValueText = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();

        const changedExistingTextOrType = Helper.hasValue(this._currentEditableComment.entry) &&
            (this._currentEditableComment.text !== this._currentEditableComment.entry.Text ||
                this._currentEditableComment.entry.Type !== this._currentEditableComment.texttype);

        const newText = Helper.hasValue(this._addText) && this._addText.trim() !== "";

        sheet.trigger(SheetEventType.Custom,
            { command: "ConversationHistoryText", changedExistingTextOrType: changedExistingTextOrType, newText: newText })
    }

    componentDidUpdate() {
        this._triggerValueText();


        if (this._scrollAndFocus) {
            this.scrollAndFocusComponent();
            this._scrollAndFocus = false;
        }
        this._stufe = Helper.evalEntityProperty<EntityTicket>("Stufe", this.props.handleEval);
    }

    private onTextFocus = () => {
        if (!this.state.isTextFocused) {
            this.setState({ isTextFocused: true });
        }
    }

    private onBlur = () => {
        if (this.state.isTextFocused && Helper.isNullOrEmpty(this._addText)) {
            this.setState({ isTextFocused: false });
        }
    }

    onItemCheckBoxChange = (id: any, event: any) => {
        const ft = this.state.filterType.slice(0);

        if (ft.indexOf(id) === -1) {
            ft.push(id)
        } else {
            const idx = ft.indexOf(id);
            ft.splice(idx, 1);
        }

        Helper.saveDataToStorage("conversationHistoryFilter", ft, false);

        this.setState({
            filterType: ft
        })

        if (event) {
            //
        }
    }

    renderCommentInputTop = (btnsArea: any, textArea: any, style: any, entries: any[]) => {
        return <div>
            <style>{this.#css}</style>

            <div>
                {btnsArea}
                {textArea}
            </div>
            <div style={style} ref={(r) => this._commentsContainer = r}>
                <div style={{ display: "flex", flexDirection: "column", padding: "5px" }}>
                    {entries.map((e, i) => this._renderEntry(e, entries.length - 1 - i))}
                </div>
            </div>
        </div>

    }

    renderCommentInputBottom = (btnsArea: any, textArea: any, style: any, entries: any[]) => {
        return <div>
            <style>{this.#css}</style>

            <div style={style} ref={(r) => this._commentsContainer = r}>
                <div style={{ display: "flex", flexDirection: "column", padding: "5px" }}>
                    {entries.map(this._renderEntry)}
                </div>
            </div>

            <div>
                {btnsArea}
                {textArea}
            </div>
        </div>
    }

    render() {
        const ct = this._commentType();
        //filter => sichtbar, wenn Conversation
        const isInEdit = this._currentEditableComment.entry !== null;

        // Comments + Events nach Datum sortieren und in entries einfügen
        let entries: Array<{ type: string, timestamp: string, obj: any }> = [];
        for (let comment of this.props.comments)
            entries.push({
                type: "comment", timestamp: comment.AddDate, obj: comment
            });
        for (let event of this.props.events)
            entries.push({
                type: "event", timestamp: event.UserDateTime, obj: event
            });
        entries = entries.sort((n1, n2) => {
            if (n1.timestamp > n2.timestamp) {
                return this.props.inputboxPosition == "top" ? -1 : 1;
            }
            if (n1.timestamp < n2.timestamp) {
                return this.props.inputboxPosition == "top" ? 1 : -1;
            }
            return 0;
        });

        //Buttons + Text + SendBtn
        let textArea = null;
        let btnsArea: any;
        if (this._canWrite()) {

            let isDisabled = !this._isConversationModel() ||
                this._currentEditableComment.entry !== null;

            if (!isDisabled) {
                if (ct != 0) {
                    isDisabled = this._isCommentFiltred(ct);
                } else {
                    isDisabled = true;
                }
            }

            let isDisabledBtn = false;

            if (isDisabled) {
                isDisabledBtn = true;
            }
            else {
                isDisabledBtn = this._addText === "";
            }

            //radio buttons
            btnsArea = this._createRadioButtons(!this._isConversationModel() || isInEdit);

            const onChange = (value: any) => {
                const oldValue = this._addText;
                if (Helper.hasValue(value) && value.trim() == "")
                    this._addText = "";
                else {
                    this._addText = value;
                    this.props.onChange({ model: "entity.Conversation" }, value);
                }

                if (!!oldValue != !!value) {
                    this.setState({});
                }
            }

            // @ts-ignore
            const onKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
                if (e.key === 'Enter' && e.shiftKey && !isDisabledBtn) {
                    this._add();
                }
            };

            const textBoxAdd = (
                <>
                    <ConversationTextBox
                        mentioningActive={this.mentioningMenuActive}
                        onChange={onChange}
                        value={this._addText}
                        disabled={isDisabled}
                        isTextFocused={this.state.isTextFocused}
                        onFocus={this.onTextFocus}
                        onKeyPress={onKeyPress}
                        users={this.users}
                        onBlur={this.onBlur}
                    />
                </>
            );
            //console.log(Config.translations.savePerCrtlShift)
            const button = this.state.isTextFocused ? <>
                <Button
                    title={Config.translations.savePerCrtlShift}
                    iconName={"arrow-circle-right"}
                    buttonStyle={{ alignSelf: "flex-left", width: "72px", marginLeft: "5px" }}
                    readOnly={isDisabledBtn}
                    inactiveState={isDisabledBtn}
                    handleClick={this._add} />
            </>
                : null;

            textArea =
                (
                    <div style={{ display: "flex" }}>
                        {textBoxAdd}
                        {button}
                    </div>
                );
        }
        else {
            btnsArea = <div style={{ display: "flex" }}>{this._renderMenu(0, isInEdit)}</div>
        }

        // @ts-ignore
        const style: React.CSSProperties = { overflowY: "auto", marginBottom: "5px" };
        if (!this.props.noScrollbars) {
            style.maxHeight = "400px";
        }

        if (this.props.inputboxPosition == "top") {
            return this.renderCommentInputTop(btnsArea, textArea, style, entries);
        }

        return this.renderCommentInputBottom(btnsArea, textArea, style, entries);
    }
}

class ConversationFilter extends React.Component<{ commentTypeText: any, isInEdit: boolean, isCommentFiltred: any, onItemCheckBoxChange: any, ct: any }, any>
{
    private _ddMenuRef: HTMLUListElement;
    private _ddMenu: kendo.ui.Menu;
    componentDidMount() {
        this._ddMenu = $(this._ddMenuRef).kendoMenu({
            openOnClick: true
        }).data("kendoMenu");
    }

    componentWillUnmount() {
        this._ddMenu.destroy();
    }

    render() {
        return (
            <div style={{ marginLeft: "auto" }}>
                <ul ref={(r) => this._ddMenuRef = r} id="ddMenu" className="fa-ul"  >
                    <li className="emptyItem"><span style={{ display: "inline-block" }}><FAIcon name="filter" /></span>
                        <ul>
                            <li className="menuItem"><SimpleCheckBox label={this.props.commentTypeText(1)} disabled={this.props.ct == 1 || this.props.isInEdit} value={!this.props.isCommentFiltred(1)} onChange={(e) => { this.props.onItemCheckBoxChange(1, e) }} /></li>
                            {Config.user.isExternal ? null :
                                <li className="menuItem"><SimpleCheckBox label={this.props.commentTypeText(2)} disabled={this.props.ct == 2 || this.props.isInEdit} value={!this.props.isCommentFiltred(2)} onChange={(e) => { this.props.onItemCheckBoxChange(2, e) }} /></li>
                            }
                            <li className="menuItem"><SimpleCheckBox label={this.props.commentTypeText(3)} disabled={this.props.ct == 3 || this.props.isInEdit} value={!this.props.isCommentFiltred(3)} onChange={(e) => { this.props.onItemCheckBoxChange(3, e) }} /></li>
                            <li className="menuItem"><SimpleCheckBox label={Helper.getTranslation("WebSMS.Procedure.Event")} value={!this.props.isCommentFiltred(4)} onChange={(e) => { this.props.onItemCheckBoxChange(4, e) }} /></li>
                        </ul>
                    </li>
                </ul>
            </div>
        )
    }
}

interface UserInfo {
    Name: string;
    Login: string;
    TeamsUserExists: boolean;

    Creator: boolean;
    Commentator: boolean;
    LastResponsible: boolean;

    Weight: boolean;

    Imagedocguid: string;
    MainGroup: string;
    Group: string;

    TeamsMail: string;
    Mail: string;
    Phone: string;
}

class ConversationTextBox extends React.Component<ConversationTextBoxProps, ConversationTextBoxState>{

    private ref: HTMLTextAreaElement;
    private MAX_AMOUNT_OPTIONS: number = 6;
    private LINE_HEIGHT: number = 38;
    private readonly sheet: HTMLElement;

    constructor(props: ConversationTextBoxProps) {
        super(props)
        this.sheet = General.Sheet.GetTopMostWrapper()[0];
        this.state = {
            options: [],
            left: undefined,
            top: undefined,
            triggerIdx: undefined,
            active: undefined,
            menuOpen: false
        }
    }

    private getOptions = (query: string) => {
        let data: UserInfo[];
        if (Helper.isNullOrEmpty(query))
            data = this.props.users;
        else {
            data = this.props.users.filter((user) => {
                return user.Name.toLowerCase().includes(query.toLowerCase()) || user.Login.toLowerCase().includes(query.toLowerCase());
            });
        }
        const result = [];
        for (let i = 0; (i < this.MAX_AMOUNT_OPTIONS && Helper.hasValue(data[i])); i++) {
            result.push(data[i])
        }
        return result;
    }

    private onChange = async () => {
        const value = this.ref.value;

        if (this.props.mentioningActive) {
            const positionIndex = this.ref.selectionStart
            const textBeforeCaret = value.slice(0, positionIndex)
            const tokens = textBeforeCaret.split(/\s/)
            const lastToken = tokens[tokens.length - 1]
            const triggerIdx = textBeforeCaret.endsWith(lastToken) ? textBeforeCaret.length - lastToken.length : -1
            const maybeTrigger = textBeforeCaret[triggerIdx]
            const keystrokeTriggered = maybeTrigger === '@'

            const query = textBeforeCaret.slice(triggerIdx + 1)
            const options = this.getOptions(query);

            const { top, left } = this.getCoordinates(positionIndex, options.length)

            const menuOpen = keystrokeTriggered && options.length > 0;
            if (menuOpen)
                this.sheet.style.transform = 'none';

            this.setState({
                active: 0,
                left: left,
                top: top,
                triggerIdx: triggerIdx,
                menuOpen: menuOpen,
                options: options
            });
        }

        this.props.onChange(value)
    }

    private getCoordinates = (positionIndex: number, amountOptions: number) => {
        const coords = this.getCaretCoordinates(positionIndex)
        let { top, left } = this.ref.getBoundingClientRect()

        const windowHeight = window.innerHeight;
        const menuHeight = (amountOptions + 1) * this.LINE_HEIGHT;
        if ((menuHeight + top + 10) > windowHeight) {
            top = top - menuHeight;
        }

        return {
            top: window.scrollY + coords.height + top - this.ref.scrollTop,
            left: window.scrollX + coords.left + left + this.ref.scrollLeft
        }
    }

    private getCaretCoordinates = (position: number) => {
        const properties = [
            'direction',
            'boxSizing',
            'width',
            'height',
            'overflowX',
            'overflowY',

            'borderTopWidth',
            'borderRightWidth',
            'borderBottomWidth',
            'borderLeftWidth',
            'borderStyle',

            'paddingTop',
            'paddingRight',
            'paddingBottom',
            'paddingLeft',

            'fontStyle',
            'fontVariant',
            'fontWeight',
            'fontStretch',
            'fontSize',
            'fontSizeAdjust',
            'lineHeight',
            'fontFamily',

            'textAlign',
            'textTransform',
            'textIndent',
            'textDecoration',

            'letterSpacing',
            'wordSpacing',

            'tabSize',
            'MozTabSize',
        ]

        const isFirefox = typeof window !== 'undefined' && window['mozInnerScreenX'] != null

        const div = document.createElement('div')
        document.body.appendChild(div)

        const style = div.style
        const computed = getComputedStyle(this.ref)

        style.whiteSpace = 'pre-wrap'
        style.wordWrap = 'break-word'
        style.position = 'absolute'
        style.visibility = 'hidden'

        properties.forEach(prop => {
            style[prop] = computed[prop]
        })

        if (isFirefox) {
            if (this.ref.scrollHeight > parseInt(computed.height))
                style.overflowY = 'scroll'
        } else {
            style.overflow = 'hidden'
        }

        div.textContent = this.ref.value.substring(0, position)

        const span = document.createElement('span')
        span.textContent = this.ref.value.substring(position) || '.'
        div.appendChild(span)

        const coordinates = {
            top: span.offsetTop + parseInt(computed['borderTopWidth']),
            left: span.offsetLeft + parseInt(computed['borderLeftWidth']),
            height: span.offsetHeight
        }

        div.remove()

        return coordinates
    }

    private onBlur = () => {
        this.props.onBlur();
        this.closeMenu();
    }

    private closeMenu = () => {
        this.setState({ options: [], left: undefined, top: undefined, triggerIdx: undefined, menuOpen: false }, () => {
            this.sheet.style.transform = 'translateY(0%)';
        })
    }

    private selectItem = (active: number) => {
        const replaceFn = (user: UserInfo, _trigger: string) => {
            return `[~${user.Login}] `;
        }

        return () => {
            const preMention = this.props.value.slice(0, this.state.triggerIdx)
            const option = this.state.options[active]
            const mention = replaceFn(option, this.props.value[this.state.triggerIdx])
            const postMention = this.props.value.slice(this.ref.selectionStart)
            const newValue = `${preMention}${mention}${postMention}`
            this.props.onChange(newValue)
            const caretPosition = this.ref.value.length - postMention.length
            this.ref.setSelectionRange(caretPosition, caretPosition)
            this.closeMenu()
            this.ref.focus()
        }
    }

    private onKeyDown = (ev: any) => {
        let keyCaught = false
        if (Helper.hasValue(this.state.triggerIdx) && this.state.menuOpen) {
            switch (ev.key) {
                case 'ArrowDown':
                    this.setState({ active: Math.min(this.state.active + 1, this.state.options.length - 1) })
                    keyCaught = true
                    break
                case 'ArrowUp':
                    this.setState({ active: Math.max(this.state.active - 1, 0) })
                    keyCaught = true
                    break
                case 'Enter':
                case 'Tab':
                    this.selectItem(this.state.active)()
                    keyCaught = true
                    break
            }
        }

        if (keyCaught) {
            ev.preventDefault()
        }
    }

    private renderMenu = () => {
        if (!this.state.menuOpen)
            return <></>;


        // @ts-ignore
        const style: React.CSSProperties = {
            backgroundColor: "#f3f3f3",
            position: "fixed",
            left: this.state.left + 'px',
            top: this.state.top + 'px',
            zIndex: 15,
            borderRadius: "var(--border-radius)"
        }

        const renderMenuItem = (user: UserInfo, setItem: () => void, selected: boolean) => {
            const createTag = (translation: string) => {
                return (
                    <div key={user.Login + "_" + translation} className={"conversation_history__menu_item__tag"} >{Helper.getTranslation(translation).toUpperCase()}</div>
                );
            }
            const tags = [];
            if (user.Creator)
                tags.push(createTag("WebSMS.Ticket.Mentioning.Creator"))

            if (user.Commentator)
                tags.push(createTag("WebSMS.Ticket.Mentioning.Commentator"))

            if (user.LastResponsible)
                tags.push(createTag("WebSMS.Ticket.Mentioning.LastResponsible"))


            return (
                <div role="option" className={"conversation_history__menu_item" + (selected ? " selected" : "")} aria-selected={!selected} onClick={setItem} key={user.Login} onTouchStart={setItem} onMouseDown={setItem} >
                    <div style={{ gridColumn: "1/2" }}>
                        <ProfilePicture id={user.Imagedocguid} userName={user.Name} />
                    </div>
                    <div style={{ gridColumn: "2/3" }}>
                        <div style={{ width: "fit-content", fontSize: "1.1em", marginLeft: "0.4em", display: "flex", alignItems: "center" }} >
                            {user.Name}
                        </div>
                    </div>
                    <div style={{ gridColumn: "3/4" }}>
                        <div style={{ display: "flex", flexDirection: "row-reverse", maxWidth: "220px", flexWrap: "wrap" }} >
                            {tags}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div role="listbox" style={style}>
                {this.state.options.map((option, idx) => { return renderMenuItem(option, this.selectItem(idx), this.state.active === idx) })}
                <div role="option" className={"conversation_history__menu_item last_item"} style={{ backgroundColor: "#d3d3d3" }} aria-selected={false}>
                    <div style={{ width: "fit-content", fontStyle: "italic", gridColumn: "1/3" }} >
                        {Helper.getTranslation("WebSMS.Ticket.Mentioning.EnterName")}
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (this.sheet) {
            const wrapper = this.sheet.querySelector('.grid-layout-wrapper');
            wrapper.addEventListener('scroll', this.closeMenu);
        }
    }

    componentWillUnmount() {
        this.sheet.style.transform = 'translateY(0%)';
    }

    render() {
        const height = this.props.isTextFocused ? "180px" : "40px";
        return (
            <>
                <div style={{ flex: "1" }}>
                    <style>
                        {`  
    .conversation_history__menu_item {
        cursor: default;
        padding: 0.3em;
        width: 500px;
        display: grid;
        grid-template-columns: 30px auto 220px;
        grid-template-rows: auto;
        min-height: ${this.LINE_HEIGHT}px;
        align-items: center;
    }

    .conversation_history__menu_item:first-child{
        border-radius: var(--rounded-top)
    }

    .conversation_history__menu_item:last-child{
        border-radius: var(--rounded-bottom)
    }

    .conversation_history__menu_item:nth-child(even) {
        background-color: #e3e3e3;
    }
  
    .conversation_history__menu_item.selected {
        background-color: var( --primary-color);
        color: white;
    }
  
    .conversation_history__menu_item:hover:not(.selected):not(.last_item) {
        background-color: #939393;
        color: #ffffff;
    }

    .conversation_history__menu_item:hover:not(.selected) .conversation_history__menu_item__tag{
        background-color: #ffffff;
    }

    .conversation_history__menu_item img{
        height: 27px;
        border-top-left-radius: 50% 50%; 
        border-top-right-radius: 50% 50%; 
        border-bottom-right-radius: 50% 50%; 
        border-bottom-left-radius: 50% 50%;
    }

    .conversation_history__menu_item__tag{
        font-size: 0.75em;
        margin: 1px;

        padding: 3px;
        border: #3f51b5 1px solid;
        color: #311b92;
        height: 25px;
        border-radius: var(--border-radius);
        background-color: #f3f3f3;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .conversation_history__menu_item:nth-child(even) .conversation_history__menu_item__tag {
        background-color: #e3e3e3;
    }

    .conversation_history__menu_item.selected .conversation_history__menu_item__tag {
        background-color: #ffffff;
    }

                    `}
                    </style>
                    <span className="k-input k-textarea k-input-solid k-input-md k-rounded-md k-resize-none k-valid">
                        <textarea
                            className="!k-overflow-auto k-input-inner"
                            ref={(ref) => { this.ref = ref; }}
                            style={{
                                height: height,
                                minHeight: height,
                                width: "100%",
                                minWidth: "100%",
                                maxWidth: "100%",
                                resize: "none"
                            }}
                            value={this.props.value || ""}
                            onChange={this.onChange}
                            onFocus={this.props.onFocus}
                            onKeyPress={this.props.onKeyPress}
                            onKeyDown={this.onKeyDown}
                            readOnly={this.props.disabled}
                            onBlur={this.onBlur} />
                    </span>
                    {this.renderMenu()}
                </div>
            </>
        );
    }
}

interface ConversationTextBoxProps {
    value: string;
    onChange: (value: string) => void;
    // @ts-ignore
    onKeyPress: (e: React.KeyboardEvent<HTMLElement>) => void;
    onFocus: () => void;
    onBlur: () => void;
    disabled: boolean;
    isTextFocused: boolean;
    users: UserInfo[];
    mentioningActive: boolean;
}

interface ConversationTextBoxState {
    options: UserInfo[];
    active: number;
    left: number;
    top: number;
    triggerIdx: number;
    menuOpen: boolean;
}

class ProfilePicture extends React.Component<{ id: string, userName: string }, { state: ProfilePictureState }>{
    private imgRef: HTMLImageElement;

    constructor(props: { id: string, userName: string }) {
        super(props)
        this.state = {
            state: Helper.isNullOrEmpty(this.props.id) ? ProfilePictureState.None : ProfilePictureState.Loading
        }
    }

    private onLoad = () => {
        this.setState({ state: ProfilePictureState.Loaded })
    }

    private onError = () => {
        this.setState({ state: ProfilePictureState.None })
    }

    private setRef = (ref: HTMLImageElement) => {
        this.imgRef = ref;
    }

    componentWillUnmount() {
        if (this.imgRef)
            this.imgRef.src = null;
    }

    render() {
        return (
            <React.Fragment key={this.props.id}>
                {Helper.isNullOrEmpty(this.props.id) ? null :
                    <div style={{ display: this.state.state == ProfilePictureState.Loaded ? "flex" : "none", justifyContent: "center", alignItems: "center" }}>
                        <img onLoad={this.onLoad} ref={this.setRef} src={`${Config.baseUrl}Thumbnail/Get/${this.props.id}`} onError={this.onError} alt="" />
                    </div>
                }
                <div style={{ display: this.state.state == ProfilePictureState.Loading ? "flex" : "none", justifyContent: "center", alignItems: "center" }} >
                    <i className="fa-regular fa-spinner spinner" style={{ height: "20px" }} />
                </div>
                <div style={{ display: this.state.state == ProfilePictureState.None ? "flex" : "none", justifyContent: "center", alignItems: "center" }}>
                    {DefaultProfilePictureGenerator.generateJSX({ background: "bright", form: "circle", name: this.props.userName, size: 25 })}
                </div>
            </React.Fragment>
        );
    }
}

enum ProfilePictureState {
    Loading,
    Loaded,
    None
}

class ProfilePictureWrapper extends React.Component<ProfilePictureWrapperProps, ProfilePictureWrapperState>{

    constructor(props: ProfilePictureWrapperProps) {
        super(props)

        this.state = {
            infoVisibile: false
        }
    }

    private renderProfilePicture = (size: number) => {
        if (this.props.userInfo != null && !Helper.isNullOrEmpty(this.props.userInfo.Imagedocguid)) {
            return <img src={`${Config.baseUrl}Thumbnail/Get/${this.props.userInfo.Imagedocguid}`} style={{ borderRadius: "50%", height: size + "px", width: size + "px" }} onError={(e) => { this.onImgError(e, size) }} alt="" ></img>
        } else {
            return DefaultProfilePictureGenerator.generateJSX({ name: this.props.userInfo.Name, size: size, background: "bright", form: "circle" })// this.props.userInfo.Name, size);
        }
    }

    private onImgError = (event: any, size: number) => {
        const target = event.target;
        const replacement = DefaultProfilePictureGenerator.generateNode(this.props.userInfo.Name, size);
        target.replaceWith(replacement)
    }

    private renderInfoLabel = (label: string, pos: number) => {
        return (
            <div style={{ gridRow: `${pos}/${pos + 1}`, gridColumn: "3/4", display: "flex", alignItems: "center" }}>
                <label>
                    {label}
                </label>
            </div>
        );
    }

    private renderTeamsButton = (icon: string, link: string) => {
        return (
            <div style={{ display: "flex" }} className="userinfo_wrapper__infogrid__button" onClick={this.addOnButtonClick(link)} title={link}>
                <span>
                    <i className={`fa-regular fa-${icon}`} aria-hidden="true" style={{ fontSize: "x-large" }} data-style="light"></i>
                    {/*<i className={`fa-solid fa-${icon}`} aria-hidden="true" style={{ fontSize: "x-large" }} data-style="solid"></i>*/}
                    <div style={{ backgroundColor: "#464eb8", color: "white", borderRadius: "25%", height: "15px", width: "15px", position: "relative", top: "-8px", left: "20px" }}>
                        <i className="fa-regular fa-t" aria-hidden="true" style={{ fontSize: "12px", position: "relative", top: "1px", left: "3px" }}></i>
                    </div>
                </span>
            </div>
        );
    }


    private renderButton = (icon: string, link: string) => {
        return (
            <div style={{ display: "flex" }} className="userinfo_wrapper__infogrid__button" onClick={this.addOnButtonClick(link)} title={link}>
                <span>
                    <i className={`fa-regular fa-${icon}`} aria-hidden="true" style={{ fontSize: "x-large" }} data-style="light"></i>
                    {/*<i className={`fa-solid fa-${icon}`} aria-hidden="true" style={{ fontSize: "x-large" }} data-style="solid"></i>*/}
                </span>
            </div>
        );
    }

    private addOnButtonClick = (link: string) => {
        return () => {
            window.open(link);
            this.setState({ infoVisibile: false })
        }
    }

    render() {
        if (!this.props.userInfo || this.props.userInfo.Login === Config.user.userName)
            return;

        const pictureSize = 120;
        return (
            <div style={{ height: "min-content", width: "min-content", gridRow: "1/2", gridColumn: "1/2" }} onMouseOver={() => { this.setState({ infoVisibile: true }) }} onMouseLeave={() => { this.setState({ infoVisibile: false }) }} >
                <style>
                    {`.userinfo_wrapper{

                        border-radius: var(--border-radius);
                        background-color: white;
                        z-index: 2;
                        border: 1px solid rgb(222, 226, 230);
                        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);
                        position: absolute;
                    }

                    .userinfo_wrapper__infogrid{
                        display: grid;
                        grid-template-rows: repeat(3, ${pictureSize / 3}px) 15px auto;
                        grid-template-columns: ${pictureSize}px 20px 1fr;
                        padding: 10px 20px 10px 10px;
                    }

                    .userinfo_wrapper__infogrid__button{margin-right: 12px; cursor: pointer}
                    .userinfo_wrapper__infogrid__button > span > i{transition: all .3s ease-in-out;}
                    .userinfo_wrapper__infogrid__button > span > i:hover{transform: scale(1.25);}

                    `}
                </style>
                {this.renderProfilePicture(40)}
                <div style={{ display: this.state.infoVisibile ? "block" : "none" }} className="userinfo_wrapper">
                    <div className="userinfo_wrapper__infogrid" >
                        <div style={{ gridRow: "1/4", gridColumn: "1/2" }}>
                            {this.renderProfilePicture(pictureSize)}
                        </div>
                        {this.renderInfoLabel(this.props.userInfo.Name, 1)}
                        {this.renderInfoLabel(this.props.userInfo.MainGroup, 2)}
                        {this.renderInfoLabel(this.props.userInfo.Group, 3)}
                        <div style={{ gridRow: "5/6", gridColumn: "1/4", display: "flex" }}>
                            {Helper.isNullOrEmpty(this.props.userInfo.Mail) ? null : this.renderButton("envelope", `mailto:${this.props.userInfo.Mail}`)}
                            {Helper.isNullOrEmpty(this.props.userInfo.Phone) ? null : this.renderButton("phone", `tel:${this.props.userInfo.Phone}`)}
                            {Helper.isNullOrEmpty(this.props.userInfo.TeamsMail) ? null : this.renderTeamsButton("comments", `https://teams.microsoft.com/l/chat/0/0?users=${this.props.userInfo.TeamsMail}`)}
                            {Helper.isNullOrEmpty(this.props.userInfo.TeamsMail) ? null : this.renderTeamsButton("headset", `https://teams.microsoft.com/l/call/0/0?users=${this.props.userInfo.TeamsMail}`)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// @ts-ignore
interface ProfilePictureWrapperProps extends React.PropsWithChildren {
    userInfo: UserInfo;
}

interface ProfilePictureWrapperState {
    infoVisibile: boolean;
}

interface TicketAppConversationHistoryProps {
    handleEval(expression: string);
    onChange(field: { model: string }, value: any, dataItem?: any);
    onAdd(item: TicketConversation);
    field: BaseField;
    context: TicketAppPropsContext;
    conversationType: number;
    comments: Array<TicketConversation>;
    events: Array<EventEntry>;
    entity: EntityTicket;
    noScrollbars?: boolean;
    inputboxPosition?: "top" | "bottom";
    additionalUrlParams?: string;
    textToHighlight?: string[];
}

export interface EventEntry {
    UserName: string;
    UserFullName: string;
    UtcDateTime: string;
    UserDateTime: string;
    Text: string;
    DokuGuid: string;
    DokuId: number;
    DokuFilename: string;
    DokuTitle: string;
    DokuRemark: string;
    DokuKategory: string;
    DokuNurIntern: number;
    JobId: number;
    EmailStatus: number;
    Email: any;
    EmailStausText: string;
    EmailError: string;
}

export interface TicketConversation {
    Id: string;
    Name: string;
    FullName: string;
    Level: number;
    IsSaved: boolean;
    IsChanged: boolean;
    Type: number;
    UTCAddDate: string; //Date
    AddDate: string; //Date
    Text: string;
}